import { Link } from "react-router-dom";
import { articles } from "@/mocks/mangaData";
import { formatViews } from "@/utils/format";

export default function NewsFeed() {
  const news = articles.filter((a) => a.categoryId === "news" || a.categoryId === "anime").slice(0, 4);

  return (
    <section className="bg-background-100 py-14" aria-labelledby="news-heading">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
          <div>
            <h2 id="news-heading" className="font-heading text-2xl text-foreground-950 md:text-3xl">
              情报速递 · 剧透预警
            </h2>
            <p className="mt-2 text-sm text-foreground-600">抢先掌握日漫情报与剧情剧透，快人一步的追更体验。</p>
          </div>
          <Link
            to="/category/news"
            className="inline-flex whitespace-nowrap items-center gap-1 text-sm text-primary-600 transition-colors hover:text-primary-700"
          >
            全部情报 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {news.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-all hover:-translate-y-0.5 hover:border-primary-200"
            >
              <div className="relative h-20 w-28 shrink-0 overflow-hidden rounded-md sm:h-24 sm:w-36">
                <img
                  src={article.cover}
                  alt={article.title}
                  className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-800">
                    {article.categoryId === "news" ? "情报" : "动画化"}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="mt-2 line-clamp-2 text-sm font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                  {article.title}
                </h3>
                <span className="mt-2 inline-flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line" />
                  {formatViews(article.views)}
                  <span className="ml-1 text-foreground-400">阅读</span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}